import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReviewMissedDataService {
  constructor(private http: HttpClient,
    private configService: ConfigService) { }

  getMissedActionDataAPI =  "/api/getmsddtalst";
  clientMasterOptionsAPI =  "/api/gtclntopts";
  crawledDataErrorsExcelAPI= "/api/genrtcrlddterrxls";

  GetMissedActionData(pagination: any) {
    return this.http.post(this.getMissedActionDataAPI, pagination);
  }

  GetClientMasterOptions() {
    return this.http.post(this.clientMasterOptionsAPI, null);
  }

  crawledDataErrorsDataToXLS() {
    const body={};
    return this.http.post(this.crawledDataErrorsExcelAPI,body);
  }
}
